import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
import { CustomSelect } from '@app/collections/shared'
import { Button, Col, Collapse, CollapsePanel, Divider, Notification, Row, Text } from '@app/components'
import { DynamicForm, generateDynamicFields } from '@app/modules'
import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import axios from 'axios'
import { ADD_NEW_ZELLE_FORM } from 'libs/data/forms/AddNewACH.form'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { BankIcon } from '~public'

export const ZellePay: React.FC<any> = ({ form, selectedMethod, setSelectedMethod }) => {
  const { zelleAccounts, fetchAccounts } = useContext(BankAccountsContext)
  const [activeKey, setActiveKey] = useState(null)

  useEffect(() => {
    fetchAccounts()
  }, [])

  const handleCollapseChange = (key) => {
    setActiveKey(key)
  }

  const { user } = useSelector((state: IStore) => state)

  const onACHSubmit = async (key) => {
    try {
      const data = await form.validateFields()
      data.identityId = user.selectedEntityName ? user.selectedEntityIdentityId : null

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      await axios.post('/api/north-one/manual-zelle', data, { headers })
    } catch (error) {
      Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to add zelle account manually: ${error}`
    } finally {
      handleCollapseChange(key)
      await fetchAccounts()
      //setSelectedMethod()
    }
  }

  /**
   * It takes the `accounts` array, maps over it, and returns an array of objects with the following
   * properties: `id`, `title`, `icon`, and `description`
   * @returns An array of objects.
   */
  const generateMethodList = () => {
    return (
      zelleAccounts
        ?.filter((item) => item.accountName !== 'none')
        .map((item) => {
          return {
            id: item.id,
            name: (
              <>
                <BankIcon /> <Text>{`${item['accountName']}`}</Text>
              </>
            ),
            //icon: <BankIcon />,
            description: 'Zelle Account',
            val: item?.id,
          }
        }) || []
    )
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <Col>
              <Text>Zelle Account</Text>
            </Col>
          </Row>
          <Divider style={{ marginTop: 0 }} />
          <CustomSelect
            type="External Account"
            selected={selectedMethod}
            setSelected={setSelectedMethod}
            list={generateMethodList()}
          />

          <Divider />

          <Collapse activeKey={activeKey} onChange={handleCollapseChange}>
            <CollapsePanel header="Add Zelle Account Manually" key="3">
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <DynamicForm
                    fields={generateDynamicFields(ADD_NEW_ZELLE_FORM, [])}
                    form={form}
                    onSubmit={onACHSubmit}
                  />
                  <Button block onClick={onACHSubmit}>
                    Add Zelle Account Manually
                  </Button>
                </Col>
              </Row>
            </CollapsePanel>
          </Collapse>
          {/*<Spacer />
          <Row>
            <Col span={24}>
              <Button
                block
                style={{ backgroundColor: '#FFFFFF', color: '#2d54a4', borderColor: '#2d54a4' }}
                href="https://intercom.help/0xcoast/en/articles/9718227-withdrawing-from-your-coast-account-to-old-glory"
                target="_blank"
              >
                Withdrawal Instructions
              </Button>
            </Col>
          </Row>*/}
        </Col>
      </Row>
    </>
  )
}
